import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ClientAssetFieldMatchInfoFragment = { __typename?: 'ClientAssetFieldMatch', id: string, fieldName: string };

export const ClientAssetFieldMatchInfo = /*#__PURE__*/ gql`
    fragment ClientAssetFieldMatchInfo on ClientAssetFieldMatch {
  id @client
  fieldName @client
}
    ` as unknown as DocumentNode<ClientAssetFieldMatchInfoFragment, unknown>;

        

        
export const useClientAssetFieldMatchInfoFragment = (
  input: string | Omit<UseFragmentOptions<ClientAssetFieldMatchInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ClientAssetFieldMatch' } };
    return input;
  })();

  return useFragment<ClientAssetFieldMatchInfoFragment>({
    fragment: ClientAssetFieldMatchInfo,
    fragmentName: 'ClientAssetFieldMatchInfo',
    ...options,
  });
};
  
        